import React from 'react';
import PropTypes from 'prop-types';
import Statgrit_logo_main from '../../assets/Statgrit_logo_main.png';
import { Link } from 'react-router-dom';

// Rename the component to avoid conflict with the built-in Error object
const ErrorPage = ({ text }) => {
  return (
    <div className='bg-[#1A1A1A]'>
      <div className="max-w-[1512px] px-6 md:px-12 w-full mx-auto flex  flex-col sm:justify-center justify-center items-center pt-6 min-h-screen bg-[#1A1A1A]">
        <img className='max-w-[560px] w-full' src={Statgrit_logo_main} alt="Statgrit_logo_main" />
        <div className='w-full p-8  text-white'>

          <div className='flex flex-col gap-10 -mt-24 justify-center items-center'>

            <div className='font-bebas text-3xl md:text-4xl lg:text-6xl text-center leading-snug'>
              {text || 'Please Select Event From Home page'}
            </div>
            <Link className='px-4 py-2 bg-primary text-sm md:text-xl lg:text-2xl rounded-md font-montserrat text-white' to="/">
              Go to Home Page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  text: PropTypes.string,
};

export default ErrorPage;